export class ProductFormBundleSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.parent = this.closest('[data-bundle-items-parent]')
    this.bundleVariantIdEls = this.parent.querySelectorAll(
      '[data-current-variant-id]',
    )

    this.checkAddToCartButton()
  }

  setupListeners () {
    super.setupListeners()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
    this.onVariantChangeHandler = this.onVariantChangeHandler.bind(this)

    this.listeners.add(this.form, 'submit', this.onSubmitHandler)

    this.listeners.add(
      window.BAO.eventBus,
      'variantAvailableChange',
      this.onVariantChangeHandler,
    )
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  onVariantChangeHandler (e) {
    this.checkAddToCartButton()
  }

  checkAddToCartButton () {
    const atcButtonEl = this.form.querySelector('button[type="submit"]')

    // Are all selected variants available?
    if (!this.allCurrentVariantsAvailable) {
      atcButtonEl.disabled = true
      // If any back-in-stock form is visible, hide the ATC button as we want
      // to use the 'Notify me' button instead.
      const bisEls = document.querySelectorAll(`[data-product-back-in-stock]`)
      const bisElVisible = [...bisEls].find(
        el => el.getAttribute('aria-hidden') !== 'true',
      )

      atcButtonEl.setAttribute('aria-hidden', bisElVisible !== undefined)

      return
    }

    // Has a selection been made in all options?
    const allOptionsSelected = [...this.bundleVariantIdEls].every(
      el => el.dataset.selectionMade === 'true',
    )

    atcButtonEl.disabled = !allOptionsSelected
    atcButtonEl.setAttribute('aria-hidden', !allOptionsSelected)
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    for (const variantId of this.bundleVariantIds) {
      await window.BAO.Cart.addItem({
        id: variantId,
        quantity: 1,
      })
    }
  }

  /**
   * @returns {Boolean}
   */
  get allCurrentVariantsAvailable () {
    return [...this.bundleVariantIdEls].every(
      el => el.dataset.currentVariantAvailable === 'true',
    )
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  /**
   * @returns {Array|null}
   */
  get bundleVariantIds () {
    return [...this.bundleVariantIdEls]
      .reverse()
      .map(el => el.dataset.currentVariantId)
  }
}

customElements.define('product-form-bundle-set', ProductFormBundleSet)
